<template>
    <v-container class="tire-form p-0">
        <v-row>
            <v-col cols="3" class="p-0">
                <v-container class="px-0">
                    <v-select
                        v-model="radius"
                        :items="availableTire"
                        height="40px"
                        label="Диаметр"
                        class="mt-2"
                        dense
                        hide-details
                        outlined
                        ref="radius"
                    ></v-select>
                </v-container>
            </v-col>
        </v-row>
        <v-row>
            <v-col class="p-0">
                <div class="custom-control custom-switch d-flex mb-1">
                    <v-switch v-model="isTire" inset label="Шина" color="success" hide-details class="mt-0"></v-switch>
                </div>
                <v-card class="p-2" :class="{'card_disabled': !isTire}">
                    <v-row>
                        <v-col cols="4">
                            <v-text-field
                                v-model="tireMarkSelect"
                                label="Марка"
                                data-test-id="TireFormMark"
                                @click="showPopUp"
                                @input="check()"
                                @blur="checkFilter"
                                autocomplete="off"
                                :rules="nameRules"
                                ref="tireMarkSelect"
                            />
                            <v-dialog
                                v-model="tireMarkPopUp"
                                width="900px"
                            >
                                <v-card>
                                    <div class="p-4" style="background-color: #C9C9C7; height: auto; overflow-y: auto;">
                                        <v-row>
                                            <v-col>
                                                <v-text-field
                                                    v-model="tireMarkSelect"
                                                    label="Марка"
                                                    @input="check()"
                                                    @blur="checkFilter"
                                                    autocomplete="off"
                                                    :rules="nameRules"
                                                />
                                            </v-col>
                                        </v-row>

                                        <h5 class="modal-title p-4 d-inline-block">Выберите марку шин:</h5>
                                        <template v-if="tireMarkSelect">
                                            <button
                                                class="btn btn-success btn-sm pr-2 carmark btn btn-options__marks__icon"
                                                @click="clearMark"
                                            >
                                              Выбрать другую
                                            </button>
                                        </template>
                                        <div class="d-flex flex-wrap justify-content-around">
                                            <template v-for="(item, index) in tireMarksFiltred">
                                                <v-btn :data-test-id="'diskMark_' + item.name" :key="'tireMarks-' + index" tile class="tiremark btn-options__marks__icon ma-2 rounded" @click="setTireMark(item.name)">
                                                    {{item.name}}
                                                </v-btn>
                                            </template>
                                        </div>
                                    </div>
                                </v-card>
                            </v-dialog>
                        </v-col>
                        <v-col cols="8">
                            <v-radio-group 
                                class="radio-group-season"
                                v-model="tireSeason" 
                                :rules="seasonRules" 
                                @input="check()"
                                @blur="checkFilter"
                                row>
                                <v-radio label="Зимняя" value="0" class="radio-season"></v-radio>
                                <v-radio label="Летняя" value="1" class="radio-season"></v-radio>
                                <v-radio label="Всесезонная" value="2" class="radio-season"></v-radio>
                            </v-radio-group>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col data-test-id="tireState">
                            <v-select
                                v-model="tireStateSelect"
                                :items="tireState"
                                placeholder="Выбрать"
                                label="Состояние"
                                :rules="nameRules"
                                ref="tireStateSelect"
                            >
                              <template v-slot:item="{item}">
                                <div :data-test-id="`tireStateValue-${item}`">
                                  {{item}}
                                </div>
                              </template>
                            </v-select>
                        </v-col>
                        <v-col
                            cols="2"
                            data-test-id="tireWidth"
                        >
                            <v-select
                                v-model="tireWidthSelect"
                                :items="tireWidth"
                                :rules="nameRules"
                                placeholder="..."
                                label="Ширина"
                                class="zxc"
                                ref="tireWidthSelect"
                            >
                              <template v-slot:item="{item}">
                                <div :data-test-id="`tireWidthValue-${item}`">
                                  {{item}}
                                </div>
                              </template>
                            </v-select>
                        </v-col>
                        <v-col cols="2"
                               data-test-id="tireHeight"
                        >
                            <v-select
                                v-model="tireHeightSelect"
                                :items="tireHeight"
                                :rules="nameRules"
                                placeholder="..."
                                label="Профиль"
                                ref="tireHeightSelect"
                            >
                              <template v-slot:item="{item}">
                                <div :data-test-id="`tireHeightValue-${item}`">
                                  {{item}}
                                </div>
                              </template>
                            </v-select>
                        </v-col>
                        <v-col col="2"
                               data-test-id="tireProfile"
                        >
                            <v-select
                                v-model="tireProfileSelect"
                                :items="tireProfile"
                                placeholder="..."
                                label="Протектор"
                                :rules="nameRules"
                                ref="tireProfileSelect"
                            >
                              <template v-slot:item="{item}">
                                <div :data-test-id="`tireProfileValue-${item}`">
                                  {{item}}
                                </div>
                              </template>
                            </v-select>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
        <v-row class="mt-3">
            <v-col class="p-0">
                <div class="custom-control custom-switch d-flex mb-1  ">
                    <v-switch v-model="isWheelDisk" inset label="Диск" color="success" hide-details class="mt-0"></v-switch>
                </div>
                <v-card class="p-2" :class="{'card_disabled': !isWheelDisk}">
                    <v-row>
                        <v-col class="disk-selecter pt-7" col="4">
                            <v-btn class="mr-auto mr-2" @click="solidDisk = true" height="51px" width="80px"  :class="solidDisk?'active':''">
                                <v-img :src="icon[1]" aspect-ratio="2" contain class="tabs_icons_big" alt="Литой диск"></v-img>
                            </v-btn>
                            <v-btn class="ml-auto" @click="solidDisk = false" height="51px" width="80px" :class="solidDisk?'':'active'">
                                <v-img :src="icon[0]" aspect-ratio="2" contain class="tabs_icons_big" alt="Штампованый диск"></v-img>
                            </v-btn>
                        </v-col>
                        <v-col cols="8" class="d-flex flex-column align-items-start justify-content-start">
                            <p class="text-left mb-0 ml-1">Колпачок:</p>
                            <v-btn-toggle mandatory v-model="hubcapSelect">
                                <v-btn>
                                    Родной
                                </v-btn>
                                <v-btn>
                                    Не родной
                                </v-btn>
                                <v-btn>
                                    Отсутствует
                                </v-btn>
                            </v-btn-toggle>
                        </v-col>
                    </v-row>
                    <v-row class="mt-2">
                        <v-col cols="5">
                            <v-container>
                                <v-select
                                    v-model="wheelDiskStateSelect"
                                    :items="wheelDiskState"
                                    placeholder="Выбрать"
                                    label="Состояние"
                                    :rules="nameRulesDisk"
                                />
                            </v-container>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>

    export default {
        props: {
            side: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                tireMarkPopUp: false,
                nameRules: [
                    v => !!v || !this.isTire || 'необходимо заполнить',
                ],
                nameRulesDisk: [
                    v => !!v || !this.isWheelDisk || 'необходимо заполнить',
                ],
                seasonRules: [
                    v => !!v || 'Выберите сезонность'
                ],
                source: 'tireStorage',
                icon: [
                    require('../../assets/shtamp.png'),
                    require('../../assets/litie.png')
                ],
                errors: {},
            }
        },
        computed: {
            tireMarksFiltred () {
                let tireMarks = []
                if(this.tireMarkSelect.length > 0 && this.tireMark && this.tireMark.length > 0){
                    let filter = this.tireMarkSelect
                    tireMarks = this.tireMark
                    filter = filter.replace(/ +/g, ' ').trim()
                    if (filter.length > 0) {
                        tireMarks = []
                        this.tireMark.map((x)=>{
                            let change = this.changeLetters(filter)
                            if( x.name.toLowerCase().indexOf(change.toLowerCase()) > -1) {
                                tireMarks.push(x)
                            }
                        })
                    }
                }  else {
                    this.tireMark.map((x)=>{
                        if(x.type==1){
                            tireMarks.push(x)
                        }
                    })
                }
                return tireMarks
            },
            availableTire () {
                return this.$store.state[this.source]['availableTire']
            },
            tireState: {
                get () {
                    return this.$store.state[this.source].availableTireState
                }
            },
            tireStateSelect: {
                get() {
                    return this.$store.state[this.source].wheels[this.side].data.tireState
                },
                set(value) {
                    this.$store.commit(this.source + '/setPlus', { side: this.side, item: 'tireState', value })
                }
            },
            radius: {
                get() {
                    return this.$store.state[this.source].wheels[this.side].data.radius
                },
                set(value) {
                    this.$store.commit(this.source + '/setPlus', { side: this.side, item: 'radius', value })
                }
            },
            tireWidth: {
                get () {
                    return this.$store.state[this.source].tireWidth
                }
            },
            tireWidthSelect: {
                get() {
                    return this.$store.state[this.source].wheels[this.side].data.tireWidth
                },
                set(value) {
                    this.$store.commit(this.source + '/setPlus', { side: this.side, item: 'tireWidth', value })
                }
            },
            tireMark: {
                get () {
                    return this.$store.state[this.source].availableTireMark
                }
            },
            tireMarkSelect: {
                get() {
                    return this.$store.state[this.source].wheels[this.side].data.tireMark
                },
                set(value) {
                    this.$store.commit(this.source + '/setPlus', { side: this.side, item: 'tireMark', value })
                }
            },
            tireHeight: {
                get () {
                    return this.$store.state[this.source].tireHeight
                }
            },
            tireHeightSelect: {
                get() {
                    return this.$store.state[this.source].wheels[this.side].data.tireHeight
                },
                set(value) {
                    this.$store.commit(this.source + '/setPlus', { side: this.side, item: 'tireHeight', value })
                }
            },
            tireProfile: {
                get () {
                    return this.$store.state[this.source].availableProfile
                }
            },
            tireProfileSelect: {
                get() {
                    return this.$store.state[this.source].wheels[this.side].data.tireProfile
                },
                set(value) {
                    this.$store.commit(this.source + '/setPlus', { side: this.side, item: 'tireProfile', value })
                }
            },
            wheelDiskState: {
                get () {
                    return this.$store.state[this.source].availableWheelDiskState
                }
            },
            wheelDiskStateSelect: {
                get() {
                    return this.$store.state[this.source].wheels[this.side].data.wheelDiskState
                },
                set(value) {
                    this.$store.commit(this.source + '/setPlus', { side: this.side, item: 'wheelDiskState', value })
                }
            },
            isTire: {
                get() {
                    return this.$store.state[this.source].wheels[this.side].data.isTire
                },
                set(value) {
                    this.$store.commit(this.source + '/setPlus', { side: this.side, item: 'isTire', value })
                }
            },
            isWheelDisk: {
                get() {
                    return this.$store.state[this.source].wheels[this.side].data.isWheelDisk
                },
                set(value) {
                    this.$store.commit(this.source + '/setPlus', { side: this.side, item: 'isWheelDisk', value })
                }
            },
            tireSeason: {
                get() {
                    return this.$store.state[this.source].wheels[this.side].data.tireSeason
                },
                set(value) {
                    this.$store.commit(this.source + '/setPlus', { side: this.side, item: 'tireSeason', value })
                }
            },
            solidDisk: {
                get() {
                    return this.$store.state[this.source].wheels[this.side].data.solidDisk
                },
                set(value) {
                    this.$store.commit(this.source + '/setPlus', { side: this.side, item: 'solidDisk', value })
                }
            },
            hubcapSelect: {
                get() {
                    return this.$store.state[this.source].wheels[this.side].data.hubcap
                },
                set(value) {
                    this.$store.commit(this.source + '/setPlus', { side: this.side, item: 'hubcap', value })
                }
            },
        },
        watch:{
            isTire (val) {
                if(!val&&!this.isWheelDisk){
                    this.isWheelDisk=!this.isWheelDisk
                }
            },
            isWheelDisk (val) {
                if(!val&&!this.isTire){
                    this.isTire=!this.isTire
                }
            },
            firstName: function (val) {
              this.fullName = val + ' ' + this.lastName
            },
        },
        methods: {
            changeLetters(str) {
                var replace = new Array(
                    "й","ц","у","к","е","н","г","ш","щ","з","х","ъ",
                    "ф","ы","в","а","п","р","о","л","д","ж","э",
                    "я","ч","с","м","и","т","ь","б","ю"
                );
                var search = new Array(
                    "q","w","e","r","t","y","u","i","o","p","\\[","\\]",
                    "a","s","d","f","g","h","j","k","l",";","'",
                    "z","x","c","v","b","n","m",",","\\."
                );

                for (var i = 0; i < replace.length; i++) {
                    var reg = new RegExp(replace[i], 'mig');
                    str = str.replace(reg, function (a) {
                        return a == a.toLowerCase() ? search[i] : search[i].toUpperCase();
                    })
                }
                return str
            },
            clearMark(){
                this.tireMarkSelect = ''
            },
            checkFilter () {
                // костыль чтобы успеть нажать кнопку
                setTimeout(()=>{
                    let tempfilter = this.tireMarkSelect
                    let index = null
                    this.tireMark.map((x,i)=>{
                        if(x.name.toLowerCase()===tempfilter.toLowerCase()){
                            index = i
                        }
                    })
                    if(index){
                        this.tireMarkSelect = this.tireMark[index].name
                    } else {
                        this.tireMarkSelect = ''
                    }
                },100)
            },
            check () {
                if(this.tireMarkSelect.length>0) {
                    if (this.tireMarkSelect.length > 1) {
                        if (this.tireMarksFiltred.length === 1) {
                            this.tireMarkSelect = this.tireMarksFiltred[0].name
                            this.hide()
                        }
                    }
                }
            },
            checkSeason () {
                this.errors = {};
                if (this.tireSeason === null || this.tireSeason === undefined) {
                this.errors.tireSeason = 'Выберите сезон шин';
                }
            },
            setTireMark(item) {
                this.tireMarkSelect = item
                this.tireMarkPopUp = false
            },
            hide() {
              this.tireMarkPopUp = false
            },
            showPopUp() {
              this.tireMarkPopUp = true
            },
            changeTireMark(e) {
                const mark = e;
                const res = [...this.tireMark].map(item =>
                    item.value === mark ? {...item, selected: true} : {...item, selected: false}
                );
                this.$store.commit('setTireMark', {value: res, side: this.side});
            },
        }
    }
</script>

<style scoped lang="scss">
    .tiremark {
        width: 10vw;
    }
    .disk-selecter .active {
        background-color: #FFFBCD !important;
    }

    .tire-form {
    }

    .custom-switch {
        label, input {
            cursor: pointer;
        }
    }

    .card_disabled:after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        z-index: 999;
        opacity: 0.7;
        width: 100%;
        height: 100%;
        background: #ffffff;
        border-radius: 4px;
    }

</style>
